// React Dependencies
import React from 'react';

// External Dependencies
import { Button } from '@material-ui/core';

const MasterReview = () => {
  const toMasterNamesPageHandler = () => {
    const url = '/admin/reviews/masterNames';
    window.open(url, '_blank');
  };

  return (
    <div className="d-flex align-items-center py-4 border-top border-bottom border-dark">
      <h4>Review Location’s Master Name</h4>
      <Button className="ml-3" variant="contained" color="primary" onClick={toMasterNamesPageHandler}>Manage</Button>
    </div>
  );
};

export default MasterReview;
